/* Capable by Design — Pressed Botanical theme JS
 * Mobile nav, life-skills tabs, sample-day lightbox, PDP quantity stepper.
 * Minimal, dependency-free; motion respects prefers-reduced-motion via CSS.
 */
(function () {
  "use strict";

  /* Mobile nav toggle */
  var toggle = document.querySelector("[data-nav-toggle]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  if (toggle && mobileNav) {
    toggle.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.querySelector("[data-icon-menu]").style.display = open ? "none" : "";
      toggle.querySelector("[data-icon-close]").style.display = open ? "" : "none";
    });
    mobileNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobileNav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        toggle.querySelector("[data-icon-menu]").style.display = "";
        toggle.querySelector("[data-icon-close]").style.display = "none";
      });
    });
  }

  /* Life skills tabs */
  document.querySelectorAll("[data-tabs]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-tab]");
    var panels = root.querySelectorAll("[data-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.getAttribute("data-tab");
        if (tab.scrollIntoView) {
          tab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
        tabs.forEach(function (t) {
          t.classList.toggle("is-active", t === tab);
          t.setAttribute("aria-selected", t === tab ? "true" : "false");
        });
        panels.forEach(function (p) {
          var active = p.getAttribute("data-panel") === target;
          p.classList.toggle("is-active", active);
          if (active) {
            /* retrigger stagger animation */
            p.querySelectorAll(".fade-up").forEach(function (el) {
              el.style.animation = "none";
              void el.offsetWidth;
              el.style.animation = "";
            });
          }
        });
      });
    });
  });

  /* Lightbox */
  document.querySelectorAll("[data-lightbox-open]").forEach(function (btn) {
    var id = btn.getAttribute("data-lightbox-open");
    var box = document.getElementById(id);
    if (!box) return;
    var close = function () {
      box.classList.remove("is-open");
      document.body.style.overflow = "";
    };
    btn.addEventListener("click", function () {
      box.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
    box.querySelectorAll("[data-lightbox-close]").forEach(function (c) {
      c.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  });

  /* PDP quantity stepper */
  document.querySelectorAll("[data-qty]").forEach(function (root) {
    var input = root.querySelector("input");
    root.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var delta = parseInt(btn.getAttribute("data-qty-delta"), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = val;
      });
    });
  });

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.querySelector("[data-cart-drawer]");
  var drawerItems = drawer ? drawer.querySelector("[data-cart-drawer-items]") : null;
  var drawerFoot = drawer ? drawer.querySelector("[data-cart-drawer-foot]") : null;
  var drawerSubtotal = drawer ? drawer.querySelector("[data-cart-drawer-subtotal]") : null;
  var drawerNote = drawer ? drawer.querySelector("[data-cart-drawer-note]") : null;
  var drawerAdded = drawer ? drawer.querySelector("[data-cart-drawer-added]") : null;
  var addedTimer = null;

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2);
    if (n.slice(-3) === ".00") n = n.slice(0, -3);
    return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function applyCartCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : "none";
    });
  }

  function renderDrawer(cart) {
    if (!drawerItems) return;
    applyCartCount(cart);
    if (cart.item_count === 0) {
      drawerItems.innerHTML =
        '<div class="cart-drawer__empty">' +
        "<p>Your basket is empty.</p>" +
        '<a class="btn-outline" href="/#shop" data-cart-drawer-close>Browse the curriculum</a>' +
        "</div>";
      if (drawerFoot) drawerFoot.style.display = "none";
      bindDrawerClosers();
      return;
    }
    var html = "";
    cart.items.forEach(function (item) {
      var img = item.image
        ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, "_160x160$1$2")
        : "";
      var compare = "";
      html +=
        '<div class="drawer-line" data-line-key="' + item.key + '">' +
        (img ? '<img class="drawer-line__img" src="' + img + '" alt="" loading="lazy">' : "<div></div>") +
        "<div>" +
        '<a class="drawer-line__title" href="' + item.url + '">' + item.product_title + "</a>" +
        '<p class="drawer-line__price">' + formatMoney(item.price) + "</p>" +
        '<div class="drawer-line__row">' +
        '<span class="drawer-line__qty">' +
        '<button type="button" data-line-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
        "<span>" + item.quantity + "</span>" +
        '<button type="button" data-line-qty="1" aria-label="Increase quantity">+</button>' +
        "</span>" +
        '<span class="drawer-line__total">' + formatMoney(item.final_line_price) + "</span>" +
        "</div>" +
        '<button type="button" class="drawer-line__remove" data-line-remove>Remove</button>' +
        "</div>" +
        "</div>";
    });
    drawerItems.innerHTML = html;
    if (drawerFoot) drawerFoot.style.display = "";
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    if (drawerNote) {
      var hasHolidayBox = cart.items.some(function (item) { return item.requires_shipping && item.handle === "12-days-of-celebrations-december-around-the-world"; });
      var hasOtherPhysical = cart.items.some(function (item) { return item.requires_shipping && item.handle !== "12-days-of-celebrations-december-around-the-world"; });
      var notes = [];
      if (hasOtherPhysical) notes.push("Physical curriculum boxes are made to order · please allow processing time · free shipping included");
      if (hasHolidayBox) notes.push("Holiday box: free US shipping · digital files delivered by email after payment");
      if (!hasOtherPhysical && !hasHolidayBox) notes.push("Instant downloads are delivered by email after checkout");
      drawerNote.textContent = notes.join(". ");
    }
    bindLineControls();
  }

  function refreshCart() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        return cart;
      });
  }

  function openDrawer(showAdded) {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    if (drawerAdded) {
      clearTimeout(addedTimer);
      if (showAdded) {
        drawerAdded.style.display = "";
        addedTimer = setTimeout(function () {
          drawerAdded.style.display = "none";
        }, 4000);
      } else {
        drawerAdded.style.display = "none";
      }
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
  }

  function bindDrawerClosers() {
    if (!drawer) return;
    drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (el) {
      if (el.dataset.boundClose) return;
      el.dataset.boundClose = "1";
      el.addEventListener("click", function (e) {
        if (el.tagName === "A" && el.getAttribute("href") && el.getAttribute("href") !== "#") {
          closeDrawer();
          return; /* allow navigation */
        }
        e.preventDefault();
        closeDrawer();
      });
    });
  }

  function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add("is-updating");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); })
      .catch(function () { refreshCart(); });
  }

  function bindLineControls() {
    if (!drawerItems) return;
    drawerItems.querySelectorAll(".drawer-line").forEach(function (line) {
      var key = line.getAttribute("data-line-key");
      var qtyEl = line.querySelector(".drawer-line__qty span");
      line.querySelectorAll("[data-line-qty]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var delta = parseInt(btn.getAttribute("data-line-qty"), 10);
          var q = Math.max(0, (parseInt(qtyEl.textContent, 10) || 1) + delta);
          changeLine(key, q, line);
        });
      });
      var removeBtn = line.querySelector("[data-line-remove]");
      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          changeLine(key, 0, line);
        });
      }
    });
  }

  if (drawer) {
    document.querySelectorAll("[data-cart-drawer-open]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        refreshCart().then(function () { openDrawer(false); });
        openDrawer(false);
      });
    });
    bindDrawerClosers();
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
    });
    refreshCart();
  }

  /* AJAX add-to-cart for shop grid + PDP */
  document.querySelectorAll("[data-add-to-cart]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      var data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          btn.textContent = original;
          btn.disabled = false;
          refreshCart().then(function () { openDrawer(true); });
        })
        .catch(function () {
          btn.textContent = "Try again";
          btn.disabled = false;
        });
    });
  });
})();

/* ============================================================
   Hunt popup — show once per visitor, suppress after signup
   ============================================================ */
(function () {
  "use strict";

  var popup = document.querySelector("[data-hunt-popup]");
  if (!popup) return;

  var SEEN_KEY = "cbdHuntPopupSeen";
  var SUB_KEY = "cbdHuntSubscribed";
  var AD_KEY = "cbdAdVisitor";
  var DELAY_MS = 30000;

  function safeGet(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }
  function safeSet(k, v) {
    try { localStorage.setItem(k, v); } catch (e) {}
  }

  /* Suppress the popup entirely for visitors arriving from paid ads
     (fbclid / gclid / utm params). Persist the flag so it stays suppressed
     on subsequent pages within the same browser. */
  var search = window.location.search || "";
  var isAdVisit = /[?&](fbclid|gclid|ttclid|msclkid|utm_source|utm_medium|utm_campaign)=/i.test(search);
  if (isAdVisit) safeSet(AD_KEY, "1");

  var path = window.location.pathname;
  var onSuppressedPage =
    path.indexOf("/cart") === 0 ||
    path.indexOf("/checkout") === 0 ||
    path.indexOf("/challenge") === 0 ||
    path.indexOf("/password") === 0;

  function openPopup() {
    popup.classList.add("is-open");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add("is-visible");
      });
    });
    popup.setAttribute("aria-hidden", "false");
    /* Lock page scroll only for the desktop modal; the mobile bottom sheet
       leaves the page scrollable behind it. */
    if (window.matchMedia("(min-width: 721px)").matches) {
      document.documentElement.style.overflow = "hidden";
    }
  }

  function closePopup() {
    popup.classList.remove("is-visible");
    popup.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    setTimeout(function () { popup.classList.remove("is-open"); }, 280);
    safeSet(SEEN_KEY, "1");
  }

  popup.querySelectorAll("[data-hunt-popup-close]").forEach(function (el) {
    el.addEventListener("click", closePopup);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.classList.contains("is-open")) closePopup();
  });

  /* Mark subscribed when the popup form is submitted */
  var popupForm = popup.querySelector("form");
  if (popupForm) {
    popupForm.addEventListener("submit", function () {
      safeSet(SUB_KEY, "1");
      safeSet(SEEN_KEY, "1");
    });
  }

  /* Also mark subscribed when the homepage email band form is submitted */
  document.querySelectorAll(".email-band__form-wrap").forEach(function (f) {
    f.addEventListener("submit", function () {
      safeSet(SUB_KEY, "1");
      safeSet(SEEN_KEY, "1");
    });
  });

  /* If the customer form posted successfully and this visitor had submitted
     via the popup, show the confirmation state once. */
  var hasSuccess = !!popup.querySelector(".hunt-popup__success");
  if (hasSuccess && safeGet(SUB_KEY) === "1" && safeGet(SEEN_KEY + "Confirmed") !== "1") {
    safeSet(SEEN_KEY + "Confirmed", "1");
    openPopup();
    setTimeout(closePopup, 4000);
    return;
  }

  if (onSuppressedPage) return;
  if (isAdVisit || safeGet(AD_KEY) === "1") return;
  if (safeGet(SUB_KEY) === "1" || safeGet(SEEN_KEY) === "1") return;

  setTimeout(function () {
    var otherOverlayOpen = document.querySelector(".cart-drawer.is-open, .lightbox.is-open");
    if (otherOverlayOpen) return; /* skip this visit; try again next visit */
    openPopup();
  }, DELAY_MS);
})();
